/**
 * @generated SignedSource<<f9041ba9f9be760e7bc4ce975b6f4d67>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EventDetailInfo_eventSession$data = {
  readonly agenda: {
    readonly date: string;
  };
  readonly courses: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly courseBucket: {
          readonly name: string;
        } | null | undefined;
        readonly id: string;
        readonly name: string;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly displayTime: string | null | undefined;
  readonly durationMins: number | null | undefined;
  readonly endAt: string | null | undefined;
  readonly startAt: string | null | undefined;
  readonly " $fragmentType": "EventDetailInfo_eventSession";
};
export type EventDetailInfo_eventSession$key = {
  readonly " $data"?: EventDetailInfo_eventSession$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventDetailInfo_eventSession">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventDetailInfo_eventSession",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "durationMins",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayTime",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CourseConnection",
      "kind": "LinkedField",
      "name": "courses",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "CourseEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Course",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "CourseBucket",
                  "kind": "LinkedField",
                  "name": "courseBucket",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Agenda",
      "kind": "LinkedField",
      "name": "agenda",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "date",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "EventSession",
  "abstractKey": null
};
})();

(node as any).hash = "dbfc549671742c6555e2676752a8066c";

export default node;
